<template>
  <div>
    <table id="table-carac-estat">
      <tbody>
        <tr class="cor-systock">
          <td colspan="5">1. Caracterização do Item</td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Código da SKU:</td>
          <td colspan="3">{{ detalhesProduto.idproduto }}</td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Descrição (nome do item):</td>
          <td colspan="3">{{ detalhesProduto.descricao_produto }}</td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Custo de Aquisição:</td>
          <td class="ta-c">{{ item.class_abc }}</td>
          <td colspan="2">{{ classAbcDesc }}</td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Criticidade Resultado:</td>
          <td class="ta-c">{{ item.class_criticidade }}</td>
          <td colspan="2">{{ classCriticidadeDesc }}</td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Comprabilidade:</td>
          <td class="ta-c">{{ item.class_comprabilidade }}</td>
          <td colspan="2">{{ classComprabilidadeDesc }}</td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Frequência Saída:</td>
          <td class="ta-c">{{ item.class_popularidade }}</td>
          <td colspan="2">{{ classPopularidadeDesc }}</td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Fornecedor(es):</td>
          <td colspan="3">
            {{ `${fornecedor.id} - ${fornecedor.razao_social}` }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">
            Confiabilidade fornecedor (es):
          </td>
          <td colspan="3">-</td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Custo de compra:</td>
          <td>
            {{ Helpers.formatarValorMonetario(detalhesProduto.custo_unitario) }}
          </td>
          <td class="azul-claro ta-r">Preço de Venda:</td>
          <td>
            {{ Helpers.formatarValorMonetario(detalhesProduto.valor_unitario) }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Rentabilidade:</td>
          <td colspan="3">
            {{ Helpers.formatarValorMonetario(detalhesProduto.valor_unitario - detalhesProduto.custo_unitario || 0) }}
          </td>
          <!-- <td class="azul-claro ta-r">Tx Oportunidade:</td> -->
          <!-- <td>-</td> -->
        </tr>
        <!--  -->
        <tr>
          <td colspan="5" class="pa-4"></td>
        </tr>
        <tr class="cor-systock">
          <td colspan="5">2. Estatísticas Apuradas</td>
        </tr>
        <tr>
          <td colspan="2"></td>
          <td class="azul-claro">Entradas</td>
          <td class="azul-claro">Saídas</td>
          <td class="azul-claro">Saldos</td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Média:</td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.media_diaria_entrada || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.media_diaria_saida || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.media_diaria_estoque || 0) }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Desvio padrão:</td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.desv_padrao_diario_entrada || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.desv_padrao_diario_saida || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.desv_padrao_diario_estoque || 0) }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">
            Coef de variabilidade (CV):
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValorComCasas(item.coef_var_entrada * 100, 2) }}%
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValorComCasas(item.coef_var_saida * 100, 2) }}%
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValorComCasas(item.coef_var_estoque * 100, 2) }}%
          </td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Máximo:</td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.max_entrada || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.max_saida || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.max_estoque || 0) }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Soma:</td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.total_entradas || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.total_saidas || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.total_estoque_medio || 0) }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Número de ocorrências:</td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.num_occorrencias_entrada || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.num_occorrencias_saida || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.num_occorrencias_estoque || 0) }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Giro do estoque:</td>
          <td colspan="2" class="ta-c">
            {{ Helpers.formatarValor(item.giro_estoque || 0) }}
            vezes/ano
          </td>
          <td class="ta-c"></td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Cobertura média:</td>
          <td colspan="2" class="ta-c">
            {{ Helpers.formatarValor(item.cobertura_media || 0) }} dias
          </td>
          <td class="ta-c">-</td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Popularidades:</td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.popularidade_entrada || 0) }}
          </td>
          <td class="ta-c">
            {{ Helpers.formatarValor(item.popularidade_saida || 0) }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">Sincronia:</td>
          <td colspan="2" class="ta-c">
            {{ Helpers.formatarValor(item.sincronia || 0) }} Saídas/Entradas
          </td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">
            Capital de giro investido:
          </td>
          <td colspan="2" class="ta-c">
            {{
              Helpers.formatarValorMonetario(
                detalhesProduto.custo_unitario * item.total_estoque_medio || 0
              )
            }}
          </td>
          <td></td>
        </tr>
        <!-- <tr>
          <td colspan="2" class="azul-claro ta-r">Custo do capital de giro:</td>
          <td colspan="2" class="ta-c">-</td>
          <td></td>
        </tr> -->
        <!--  -->
        <tr>
          <td colspan="5" class="pa-4"></td>
        </tr>
        <tr>
          <td colspan="2"></td>
          <td class="azul-claro ta-c">TMER</td>
          <td class="azul-claro ta-c">TMEA</td>
          <td></td>
        </tr>
        <tr>
          <td colspan="2" class="azul-claro ta-r">
            Tempos médios entre transações:
          </td>
          <td class="ta-c">{{ Helpers.formatarValor(item.tmer || 0) }} dias</td>
          <td class="ta-c">{{ Helpers.formatarValor(item.tmea || 0) }} dias</td>
          <td></td>
        </tr>
        <!--  -->
        <tr>
          <td colspan="5" class="pa-4"></td>
        </tr>
        <tr>
          <td></td>
          <td class="azul-claro ta-c">Esseg</td>
          <td class="azul-claro ta-c">PP</td>
          <td class="azul-claro ta-c">Emáx</td>
          <td class="azul-claro ta-c">CM</td>
        </tr>
        <tr>
          <td class="azul-claro ta-r">Limite Sup</td>
          <td class="ta-r">{{ Helpers.formatarValor(item.max_esseg || 0) }}</td>
          <td class="ta-r">{{ Helpers.formatarValor(item.max_ppd || 0) }}</td>
          <td class="ta-r">{{ Helpers.formatarValor(item.max_emax || 0) }}</td>
          <td class="ta-r">{{ Helpers.formatarValor(item.max_cmm || 0) }}</td>
        </tr>
        <tr>
          <td class="azul-claro ta-r">Limite Inf</td>
          <td class="ta-r">{{ Helpers.formatarValor(item.min_esseg || 0) }}</td>
          <td class="ta-r">{{ Helpers.formatarValor(item.min_ppd || 0) }}</td>
          <td class="ta-r">{{ Helpers.formatarValor(item.min_emax || 0) }}</td>
          <td class="ta-r">{{ Helpers.formatarValor(item.min_cmm || 0) }}</td>
        </tr>
        <tr>
          <td class="azul-claro ta-r">Amplitude</td>
          <td class="ta-r">
            {{ Helpers.formatarValor(item.amplitude_esseg || 0) }}
          </td>
          <td class="ta-r">
            {{ Helpers.formatarValor(item.amplitude_ppd || 0) }}
          </td>
          <td class="ta-r">
            {{ Helpers.formatarValor(item.amplitude_emax || 0) }}
          </td>
          <td class="ta-r">
            {{ Helpers.formatarValor(item.amplitude_cmm || 0) }}
          </td>
        </tr>

        <!--  -->
        <tr>
          <td colspan="5" class="pa-4"></td>
        </tr>
        <tr>
          <td colspan="3" style="background: #4b088a; color: #fff">
            Saldo Acima do Emáx
          </td>
          <td class="ta-c">{{ item.saldo_acima_emax }} dias</td>
          <td class="ta-c">
            {{ Helpers.formatarValor(percSaldos(item.saldo_acima_emax)) }}%
          </td>
        </tr>
        <tr>
          <td colspan="3" style="background: #04b431; color: #fff">
            Saldo Adequado
          </td>
          <td class="ta-c">{{ item.saldo_adequado }} dias</td>
          <td class="ta-c">
            {{ Helpers.formatarValor(percSaldos(item.saldo_adequado)) }}%
          </td>
        </tr>
        <tr>
          <td colspan="3" style="background: #dba901; color: #fff">
            Saldo Exposto a Ruptura
          </td>
          <td class="ta-c">{{ item.saldo_exposto_ruptura }} dias</td>
          <td class="ta-c">
            {{ Helpers.formatarValor(percSaldos(item.saldo_exposto_ruptura)) }}%
          </td>
        </tr>
        <tr>
          <td colspan="3" style="background: #df0101; color: #fff">
            Saldo em Ruptura
          </td>
          <td class="ta-c">{{ item.saldo_ruptura }} dias</td>
          <td class="ta-c">
            {{ Helpers.formatarValor(percSaldos(item.saldo_ruptura)) }}%
          </td>
        </tr>
        <tr>
          <td colspan="3" style="background: #000; color: #fff">
            Espaço Amostral
          </td>
          <td style="background: #000; color: #fff" class="ta-c">
            {{ item.total_amostras }} dias
          </td>
          <td style="background: #000; color: #fff" class="ta-c">100%</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProdutoAPI from "../../../api/produto";

export default {
  props: ["atualizar", "qtdeMeses"],
  data: () => ({
    item: [],
    ultQtdeMeses: 0,
  }),
  computed: {
    ...mapGetters({
      filialCompra: "usuario/getFilialCompras",
      detalhesProduto: "detalhe_produto/getProduto",
      fornecedor: "fornecedor/getFornecedor",
    }),
    classAbcDesc() {
      if (!this.item.class_abc) return "";
      const abc = this.item.class_abc;
      return abc == "A" ? "Elevado" : abc == "B" ? "Intermediário" : "Baixo";
    },
    classCriticidadeDesc() {
      if (!this.item.class_criticidade) return "";
      const crit = this.item.class_criticidade;
      return crit == "Z"
        ? "Vital"
        : crit == "Y"
        ? "Intermediário"
        : "Ordinário";
    },
    classPopularidadeDesc() {
      if (!this.item.class_popularidade) return "";
      const pop = this.item.class_popularidade;
      return pop == "P" ? "Popular" : pop == "Q" ? "Média" : "Rara";
    },
    classComprabilidadeDesc() {
      if (!this.item.class_comprabilidade) return "";
      const com = this.item.class_comprabilidade;
      return com == 1 ? "Complexa" : com == 2 ? "Difícil" : "Previsível";
    },
  },
  mounted() {
    this.buscarInfoProd();
  },
  watch: {
    grupo() {
      this.buscarInfoProd();
    },
    filial() {
      this.buscarInfoProd();
    },
    atualizar() {
      if (this.atualizar) this.buscarInfoProd();
    },
    qtdeMeses() {
      if (this.qtdeMeses > 0 && this.ultQtdeMeses != this.qtdeMeses) {
        this.ultQtdeMeses = this.qtdeMeses;
        this.buscarInfoProd();
      }
    },
  },
  methods: {
    percSaldos(div) {
      const { total_amostras } = this.item;

      if (div == 0) return 0;

      return ((div - total_amostras) / total_amostras + 1) * 100;
    },

    buscarInfoProd: function () {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.detalhesProduto.id_grupo,
        filial: this.filialCompra,
        produto: this.detalhesProduto.idproduto,
        produtos: this.detalhesProduto.produtos || [],
        qtdeMeses: this.qtdeMeses,
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        ProdutoAPI.getRaioXProdutoInfo(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.item = response.data.raio_x;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
  },
};
</script>

<style>
#table-carac-estat {
  border-collapse: collapse;
  overflow-y: auto;
  width: 100%;
}
.ta-r {
  text-align: right;
}
.ta-c {
  text-align: center;
}
#table-carac-estat tbody tr td {
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 12px;
}
.cor-systock {
  background: #0d4663;
  color: #fff;
}
.azul-claro {
  background: rgba(90, 163, 199, 0.3);
  color: #000;
}
.font-bold {
  font-weight: bold;
}
</style>
